import store from '@/store/index';
import { $context } from '@/global-install/index';

export const isAllowSchedulerFreeTrial = () => {
  const { healthcareInfo, addressInfo, account, govDomainRegList, eduDomainRegList } = store.getters
  if (healthcareInfo?.agreementAccepted) {
    return false
  }

  if (addressInfo?.isForEdu && addressInfo?.coppa?.length > 0) {
    return false
  }

  if ($context.currency === 'INR') {
    return false
  }
  
  const unValidDomainList = [...govDomainRegList, ...eduDomainRegList]
  if (account?.email && !!unValidDomainList.find(item => item.test(account?.email))) {
    return false
  }

  return true
}